import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import type { SelectOptionWithColor } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { useMemo } from 'react';

import { useTagsListQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';

interface PassengerTagsContextFieldProps {
  fieldPath: string;
  label: string;
}

export default function PassengerTagsContextField({
  fieldPath,
  label,
}: PassengerTagsContextFieldProps) {
  const { data: orgTags } = useTagsListQuery({});

  const options = useMemo<SelectOptionWithColor[]>(
    () =>
      orgTags?.results.map((tag) => ({
        label: tag.tag_name,
        value: tag.id,
        color: tag.color_hex || '',
      })) ?? [],
    [orgTags]
  );

  return (
    <FormFieldController name={fieldPath}>
      {({ field, fieldState }) => {
        return (
          <FormFieldContainer>
            <DefaultFormFieldLayout
              label={label}
              error={fieldState.error?.message?.toString()}
              inputId={fieldPath}
            >
              <MultiSelect
                options={options}
                selected={field.value}
                onChange={(selected) => {
                  field.onChange(selected);
                }}
              />
            </DefaultFormFieldLayout>
          </FormFieldContainer>
        );
      }}
    </FormFieldController>
  );
}
